<script lang="ts">
  import { ArtAssetType } from '@do/models';

  import { Avatar } from '@shared/ui/avatar';
  import { formatWalletAddress } from '@shared/utils';

  export let wallet: string | undefined;
  export let type: ArtAssetType;

  $: itemName =
    type === ArtAssetType.DigitalOriginal
      ? 'Digital Original'
      : type === ArtAssetType.DigitalCommon
        ? 'Digital Native'
        : 'Item';
</script>

<article>
  <p class="text-default-500 mb-2 mt-3 text-sm">
    {itemName} has been sold to
  </p>

  {#if wallet}
    <div class="bg-default-100 dark:bg-alt-dark flex w-max items-center gap-2 rounded-full py-0.5 pl-2 pr-5">
      <div class="p-1">
        <Avatar {wallet} width="{20}" />
      </div>

      <p class="text-sm font-medium lowercase">
        {formatWalletAddress(wallet)}
      </p>
    </div>
  {/if}
</article>
